import React from 'react';
import { withRouter } from 'react-router-dom';
import {generatePath} from '../../utilities/RedirectUtils';
import {datadogRum} from "@datadog/browser-rum";
import { JourneyMonitoringContext } from '../../hoc/withJourneyMonitoring';

class ErrorBoundary extends React.Component {
  static contextType = JourneyMonitoringContext;

  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    const pathArray = this.props.location.pathname.split('/');
    const pageWithError = pathArray.pop();
    const partnerCode = pathArray.pop();

    datadogRum.addAction(`Error Boundary Triggered -${partnerCode}-${pageWithError} ${error.message}`);
    datadogRum.addError(new Error(`Error Boundary Triggered - error ${error}`));

    try {
      const { getBufferSnapshot, sessionId, callId, clientJourneyId } = this.context || {};
      datadogRum.addError(error, {
        precedingJourney: getBufferSnapshot ? getBufferSnapshot() : [],
        sessionId,
        callId,
        clientJourneyId,
      });
    } catch (journeyContextError) {
      if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('[ErrorBoundary] Failed to attach journey context to error.', journeyContextError);
      }
    }

    this.props.history.push(generatePath('sitedown', partnerCode));
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
